import * as Sentry from '@sentry/react'

import { isPaidAccount } from './validation'

const sentryContextName = 'Expandrive Teams'
const sentryTagPrefix = 'expandriveTeams'

const compactObject = object => Object.fromEntries(
  Object.entries(object).filter(([, value]) => value !== undefined && value !== null && value !== ''),
)

const tagValue = value => {
  if (value === undefined || value === null || value === '') {
    return 'none'
  }

  return String(value)
}

const setSentryTag = (target, key, value) => {
  target.setTag(`${sentryTagPrefix}.${key}`, tagValue(value))
}

const getSentryUserContext = currentUser => {
  if (!currentUser?.id) {
    return null
  }

  return compactObject({
    id: currentUser.id,
    provider: currentUser.provider,
    type: currentUser.type,
  })
}

const getSentryAccountContext = currentAccount => {
  if (!currentAccount?.id) {
    return null
  }

  return compactObject({
    id: currentAccount.id,
    name: currentAccount.name,
    paid: isPaidAccount(currentAccount),
    period: currentAccount.period,
    serverInstanceLimit: currentAccount.serverInstanceLimit,
  })
}

const applySentryContext = ({
  currentAccount = {},
  currentUser = {},
  pathname,
  target,
}) => {
  const sentryUser = getSentryUserContext(currentUser)
  const sentryAccount = getSentryAccountContext(currentAccount)

  target.setUser(sentryUser?.id ? compactObject({
    email: currentUser.email,
    id: String(sentryUser.id),
  }) : null)

  target.setContext(`${sentryContextName} User`, sentryUser)
  target.setContext(`${sentryContextName} Account`, sentryAccount)

  setSentryTag(target, 'accountId', sentryAccount?.id)
  setSentryTag(target, 'accountPaid', sentryAccount?.paid)
  setSentryTag(target, 'accountPeriod', sentryAccount?.period)
  setSentryTag(target, 'route', pathname)
  setSentryTag(target, 'userType', sentryUser?.type)
}

export const syncSentryContext = context => {
  applySentryContext({
    ...context,
    target: Sentry,
  })
}

export const clearSentryContext = () => {
  applySentryContext({ target: Sentry })
}

export const setSentryErrorBoundaryContext = ({ scope, ...context }) => {
  if (!scope) {
    return
  }

  applySentryContext({
    ...context,
    target: scope,
  })

  scope.setTag(`${sentryTagPrefix}.errorBoundaryRoute`, context.pathname)
}
